export const faqs = [
  {
    id: 'faq-1',
    question: '性福寶安全嗎？有沒有副作用？',
    answer: '性福寶採用全天然草本配方，所有成分均經過嚴格的安全性評估。在推薦劑量下使用，一般不會產生明顯的副作用。極少數用戶可能在初次使用時出現輕微的腸胃不適，通常在使用幾天後會自行消失。如出現持續不適，請停止使用並諮詢醫生。',
  },
  {
    id: 'faq-2',
    question: '多久能看到效果？',
    answer: '由於每個人的體質不同，效果顯現的時間也會有所差異。根據大量用戶反饋，大多數人在持續使用2-4週後開始感受到積極變化，包括精力提升、疲勞感減少等。完整的效果通常在使用2-3個月後最為明顯。建議以3個月為一個完整使用週期。',
  },
  {
    id: 'faq-3',
    question: '可以長期使用性福寶嗎？',
    answer: '性福寶的配方設計考慮到了長期使用的安全性。建議以3個月為一個使用週期，之後可以根據個人情況決定是否繼續使用。長期使用者建議定期進行健康檢查，以確保身體狀況良好。',
  },
  {
    id: 'faq-4',
    question: '性福寶與其他保健品可以同時服用嗎？',
    answer: '一般來說，性福寶可以與大多數維生素及礦物質補充劑同時使用。但如果您正在服用處方藥物或其他具有特定功效的保健品，建議在使用前諮詢醫生意見，以避免潛在的相互作用。',
  },
  {
    id: 'faq-5',
    question: '女性可以使用性福寶嗎？',
    answer: '性福寶伴侶系列特別考慮了女性的需求，配方溫和，男女皆宜。經典系列和日常養護系列同樣適合女性使用。建議女性用戶從較低劑量開始，並在使用過程中留意身體反應。',
  },
  {
    id: 'faq-6',
    question: '性福寶的正品如何辨別？在哪裡購買？',
    answer: '為確保購買到正品性福寶，請務必通過官方網站或授權渠道購買。正品包裝上有防偽標籤，可通過官方網站驗證真偽。請警惕來路不明的低價產品，以保障您的權益和健康安全。',
  },
  {
    id: 'faq-7',
    question: '服用性福寶期間需要注意什麼？',
    answer: '服用性福寶期間，建議保持健康的生活方式：均衡飲食、適度運動、充足睡眠。避免過度飲酒。如正在服用處方藥物，請在使用前諮詢醫生。孕婦及哺乳期女性不建議使用。',
  },
  {
    id: 'faq-8',
    question: '性福寶的保質期是多久？如何儲存？',
    answer: '性福寶的保質期為24個月（未開封）。請存放在陰涼乾燥處，避免陽光直射和高溫環境。開封後請在3個月內使用完畢，並確保存放環境乾燥衛生。',
  },
];